import { Avatar, Badge, Flex, Text } from '@mantine/core'
import { useNavigate } from 'react-router-dom'

interface UserIdentityChipProps {
	id?: string
	name?: string
	avatar?: string
	badge?: string
	badgeColor?: string
	compact?: boolean
}

export default function UserIdentityChip({
	id,
	name,
	avatar,
	badge,
	badgeColor = 'blue',
	compact = false,
}: UserIdentityChipProps) {
	const navigate = useNavigate()

	return (
		<Flex
			align="center"
			gap={6}
			onClick={() => id && navigate(`/users/${id}`)}
			sx={{
				width: 'fit-content',
				maxWidth: compact ? 140 : 190,
				padding: compact ? '2px 7px 2px 3px' : '3px 8px 3px 4px',
				borderRadius: 999,
				cursor: id ? 'pointer' : 'default',
				backgroundColor: '#f8fafc',
				border: '1px solid #e5e7eb',
				'&:hover': id
					? {
							backgroundColor: '#eef2ff',
					  }
					: undefined,
			}}
		>
			<Avatar src={avatar} radius={50} size={compact ? 22 : 24}>
				{String(name || '?').trim().charAt(0).toUpperCase() || '?'}
			</Avatar>
			<Text size="xs" weight={600} lineClamp={1}>
				{name || '-'}
			</Text>
			{badge && (
				<Badge size="xs" radius={6} variant="light" color={badgeColor}>
					{badge}
				</Badge>
			)}
		</Flex>
	)
}
